/* MiniKin theme - core: reveal, header, drawers, cart, wishlist, accordions */
(() => {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(hover:hover) and (pointer:fine)').matches;
  const EASE = 'cubic-bezier(.22,1,.36,1)';
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const esc = (s) => String(s).replace(/[&<>]/g, (c) => '&#' + c.charCodeAt(0) + ';');
  const toast = (m) => {
    const t = document.createElement('div');
    t.className = 'toast'; t.setAttribute('role', 'status'); t.textContent = m;
    document.body.append(t); setTimeout(() => t.remove(), 3200);
  };

  /* reveal on scroll: fade-up 24px, 600ms, stagger 80ms; pop-ins for imagery */
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((es) => es.forEach((e) => {
    if (!e.isIntersecting) return;
    e.target.classList.add('in'); io.unobserve(e.target);
    setTimeout(() => e.target.style.removeProperty('--d'), 1600);
  }), { threshold: 0.12, rootMargin: '0px 0px -5% 0px' }) : null;
  const scan = (c = document) => {
    $$('[data-stagger]', c).forEach((g) => [...g.children].forEach((el, i) => {
      el.style.setProperty('--d', i * 80 + 'ms');
      if (!el.hasAttribute('data-pop')) el.setAttribute('data-reveal', '');
    }));
    $$('[data-reveal],[data-pop]', c).forEach((el) => {
      if (el.classList.contains('in')) return;
      io ? io.observe(el) : el.classList.add('in');
    });
  };

  /* delivery estimate: today + 7 days */
  const etas = () => {
    const s = new Date(Date.now() + 7 * 864e5).toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
    $$('[data-eta]').forEach((el) => { el.textContent = s; });
  };

  /* header: shrink + blur on scroll, hero parallax */
  const header = $('[data-header]');
  const par = $('[data-parallax]');
  let ticking = false;
  const onScroll = () => {
    ticking = false;
    const y = window.scrollY;
    if (header) header.classList.toggle('is-scrolled', y > 40);
    if (par && fine && !reduce && innerWidth > 900 && y < 1000) par.style.transform = 'translate3d(0,' + y * 0.4 + 'px,0)';
  };
  addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });

  /* announcement bar rotation */
  const bar = $('[data-bar]');
  if (bar) {
    const msgs = (bar.dataset.bar || '').split('|').filter(Boolean);
    const p = $('[data-bar-msg]', bar);
    let i = 0, t;
    const show = (n) => {
      i = (n + msgs.length) % msgs.length; p.textContent = msgs[i];
      p.classList.remove('swap'); void p.offsetWidth; p.classList.add('swap');
      clearInterval(t); if (!reduce) t = setInterval(() => show(i + 1), 5000);
    };
    if (msgs.length > 1) {
      bar.addEventListener('click', (e) => {
        if (e.target.closest('[data-bar-prev]')) show(i - 1);
        if (e.target.closest('[data-bar-next]')) show(i + 1);
      });
      if (!reduce) t = setInterval(() => show(i + 1), 5000);
    }
  }

  /* mega menu */
  const mb = $('[data-mega-btn]'), mega = $('[data-mega]');
  const setMega = (o) => { if (!mega) return; mega.classList.toggle('is-open', o); mb.setAttribute('aria-expanded', o); };
  if (mb && mega && fine) {
    let h;
    const on = () => { clearTimeout(h); setMega(true); }, off = () => { h = setTimeout(() => setMega(false), 180); };
    [mb, mega].forEach((el) => { el.addEventListener('mouseenter', on); el.addEventListener('mouseleave', off); });
  }

  /* drawers */
  const overlay = $('[data-overlay]');
  let lastFocus = null;
  const closeDrawer = (keep) => {
    $$('.mk-drawer.is-open').forEach((d) => { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    if (keep) return;
    overlay && overlay.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  };
  const openDrawer = (n) => {
    const d = $('[data-drawer=' + n + ']'); if (!d) return;
    if (!$('.mk-drawer.is-open')) lastFocus = document.activeElement;
    closeDrawer(true); setMega(false);
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    overlay && overlay.classList.add('is-open');
    document.body.classList.add('no-scroll');
    setTimeout(() => { const f = $('[data-close]', d); f && f.focus(); }, 80);
    if (n === 'wish') renderWish();
  };

  /* cart */
  const post = (u, b) => fetch(root + u, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(b) })
    .then(async (r) => { const j = await r.json().catch(() => ({})); if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong. Please try again.'); return j; });
  const setCount = (n) => $$('[data-cart-count]').forEach((el) => {
    const changed = el.textContent !== String(n);
    el.textContent = n; el.hidden = n < 1;
    if (changed) { el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); }
  });
  const html = (s) => { const t = document.createElement('div'); t.innerHTML = s || ''; return t; };
  /* one request redraws the drawer and (on the cart page) the page summary together,
     keeping the scroll position and the open gift box so nothing jumps */
  const refreshCart = async () => {
    const page = $('[data-cartpage]');
    const ids = ['mk-cart-drawer']; if (page && page.dataset.section) ids.push(page.dataset.section);
    const j = await fetch((page ? location.pathname : root) + '?sections=' + ids.join(',')).then((r) => r.json());
    const fresh = $('[data-cart]', html(j['mk-cart-drawer'])), cur = $('[data-cart]');
    if (fresh && cur) {
      const body = $('.mk-drawer__body', cur), y = body ? body.scrollTop : 0, gift = $('.co-gift', cur), wasOpen = gift && gift.open;
      cur.replaceWith(fresh);
      const nb = $('.mk-drawer__body', fresh); if (nb) nb.scrollTop = y;
      const ng = $('.co-gift', fresh); if (ng && wasOpen) ng.open = true;
      setCount(+fresh.dataset.count || 0);
    }
    if (page) {
      const fp = $('[data-cartpage]', html(j[page.dataset.section]));
      if (fp) { const g = $('.co-gift', page), o = g && g.open; page.replaceWith(fp); const n = $('.co-gift', fp); if (n && o) n.open = true; }
    }
    etas();
  };
  const fly = (img) => {
    const bag = $('[data-bag]');
    if (!img || !bag || reduce) return Promise.resolve();
    const a = img.getBoundingClientRect(), b = bag.getBoundingClientRect();
    const c = img.cloneNode(); c.removeAttribute('srcset'); c.removeAttribute('data-fly'); c.removeAttribute('class');
    Object.assign(c.style, { position: 'fixed', left: a.left + a.width / 2 - 24 + 'px', top: a.top + a.height / 2 - 24 + 'px', width: '48px', height: '48px', objectFit: 'cover', borderRadius: '12px', zIndex: 999, pointerEvents: 'none', opacity: 1, transform: 'none' });
    document.body.append(c);
    const dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
    return c.animate([
      { transform: 'translate(0,0) scale(1.6)' },
      { transform: 'translate(' + dx * 0.5 + 'px,' + (Math.min(dy, 0) - 90) + 'px) scale(1)', offset: 0.5 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.4)', opacity: 0.5 }
    ], { duration: 500, easing: EASE }).finished.then(() => c.remove(), () => c.remove());
  };
  /* what one tap adds. On the product page the main button and the sticky button both follow the
     chosen set ("1 Planter", "2 Planters", "Gift Duo") and the quantity next to it; every other
     button adds one unit of its own product. Gift wrap / note go on every line of that tap. */
  const itemsFor = (btn, props) => {
    const bx = $('[data-bundles]');
    const sel = bx && (btn.hasAttribute('data-bundle-add') || btn.hasAttribute('data-with-gift')) ? $('input:checked', bx) : null;
    if (sel && sel.dataset.items) {
      const q = Math.max(1, Math.min(10, +bx.dataset.qty || 1));
      const list = sel.dataset.items.split(',').map((p) => { const a = p.split(':'); return { id: +a[0], quantity: (+a[1] || 1) * q, properties: props }; }).filter((i) => i.id);
      if (list.length) return list;
    }
    return [{ id: +btn.dataset.add, quantity: 1, properties: props }];
  };
  let adding = false;
  const addToCart = async (btn, buyNow) => {
    if (!+btn.dataset.add) return;
    /* one tap = one add: everything goes to Shopify in a single request, and further taps
       (on this or any other add button) are ignored until it has finished */
    if (adding) return;
    const props = {};
    const g = $('[data-pdp-gift]');
    if (g && btn.hasAttribute('data-with-gift')) {
      if ($('[data-pdp-wrap]', g).checked) props['Gift wrap'] = 'Yes';
      const n = $('[data-pdp-note]', g).value.trim(); if (n) props['Gift note'] = n;
    }
    adding = true; btn.classList.add('is-busy'); btn.setAttribute('aria-busy', 'true');
    try {
      const items = itemsFor(btn, props);
      /* the product page's own buttons treat the chosen amount as final, so a change of mind
         ("Buy 2", back, then "1 Planter") never stacks on an earlier tap: Buy it now checks out
         only what is chosen now, and Add to Cart replaces earlier lines of the same planter
         while keeping everything else in the bag */
      if (buyNow) await post('cart/clear.js', {});
      else if (btn.hasAttribute('data-bundle-add') || btn.hasAttribute('data-with-gift')) {
        const ids = items.map((i) => i.id), updates = {};
        const cart = await fetch(root + 'cart.js').then((r) => r.json());
        cart.items.forEach((l) => { if (ids.includes(l.variant_id)) updates[l.key] = 0; });
        if (Object.keys(updates).length) await post('cart/update.js', { updates });
      }
      await post('cart/add.js', { items });
      if (buyNow) { location.href = root + 'checkout'; return; }
      const scope = btn.closest('[data-item]');
      const img = scope ? $('[data-fly]', scope) : $('[data-main-img]');
      /* the bag drawer is the confirmation. When the tap came from inside the open bag,
         it is simply redrawn in place: no flying photo and no re-opening */
      const inBag = !!btn.closest('[data-drawer=cart]');
      await Promise.all([inBag ? null : fly(img), refreshCart()]);
      if (!inBag) openDrawer('cart');
    } catch (e) {
      toast(navigator.onLine === false ? 'You seem to be offline. Please try again.' : e.message);
      btn.classList.add('shake'); setTimeout(() => btn.classList.remove('shake'), 450);
    } finally { adding = false; btn.classList.remove('is-busy'); btn.removeAttribute('aria-busy'); }
  };
  let noteT, qtyBusy = false;
  document.addEventListener('input', (e) => {
    const n = e.target.closest('[data-giftnote]'); if (!n) return;
    const c = $('[data-note-count]'); if (c) c.textContent = n.value.length + ' / 200';
    clearTimeout(noteT); noteT = setTimeout(() => post('cart/update.js', { attributes: { 'Gift note': n.value } }).catch(() => {}), 600);
  });

  /* wishlist (saved on this device) */
  const WK = 'mk-wish';
  const getW = () => { try { return JSON.parse(localStorage.getItem(WK)) || []; } catch (e) { return []; } };
  const setW = (a) => { try { localStorage.setItem(WK, JSON.stringify(a)); } catch (e) {} };
  const syncW = () => {
    const w = getW();
    $$('[data-wish]').forEach((b) => b.setAttribute('aria-pressed', w.includes(b.dataset.wish)));
    $$('[data-wish-count]').forEach((el) => { el.textContent = w.length; el.hidden = !w.length; });
  };
  const renderWish = async () => {
    const box = $('[data-wish-list]'); if (!box) return;
    const w = getW(), empty = $('[data-wish-empty]');
    empty.hidden = w.length > 0; box.hidden = !w.length;
    if (!w.length) { box.innerHTML = ''; return; }
    const ps = (await Promise.all(w.map((h) => fetch(root + 'products/' + h + '.js').then((r) => (r.ok ? r.json() : null)).catch(() => null)))).filter(Boolean);
    box.innerHTML = ps.map((p) => {
      const v = p.variants.find((x) => x.available), url = root + 'products/' + p.handle;
      return "<article class='citem' data-item><a class='ph r45' href='" + url + "'><img data-fly src='" + esc(p.featured_image || '') + "' alt=''></a>" +
        "<div style='flex:1;min-width:0;display:flex;flex-direction:column;gap:6px'><h3><a href='" + url + "'>" + esc(p.title) + "</a></h3>" +
        "<p class='t-price' style='font-size:16px'>₹" + (p.price / 100).toLocaleString('en-IN') + "</p>" +
        "<div style='display:flex;gap:14px;align-items:center;margin-top:4px'>" + (v ? "<button class='btn btn-p btn-sm' type='button' data-add='" + v.id + "'>Add to bag</button>" : '') +
        "<button class='link t-small' type='button' data-wish='" + p.handle + "'>Remove</button></div></div></article>";
    }).join('');
  };

  /* accordions: smooth height, one open per group */
  const toggleAcc = (d, open) => {
    const b = $('.acc-b', d);
    if (reduce || !b || !b.animate) { d.open = open; return; }
    if (open) {
      d.open = true;
      b.animate([{ height: 0, opacity: 0 }, { height: b.scrollHeight + 'px', opacity: 1 }], { duration: 350, easing: EASE });
    } else {
      d.classList.add('closing');
      b.animate([{ height: b.scrollHeight + 'px', opacity: 1 }, { height: 0, opacity: 0 }], { duration: 300, easing: EASE })
        .finished.then(() => { d.open = false; d.classList.remove('closing'); });
    }
  };

  document.addEventListener('click', (e) => {
    const t = e.target;
    const sum = t.closest('details.acc > summary');
    if (sum) {
      e.preventDefault();
      const d = sum.parentElement, willOpen = !d.open;
      if (willOpen) $$('details.acc[open]', d.parentElement).forEach((o) => o !== d && toggleAcc(o, false));
      return toggleAcc(d, willOpen);
    }
    if (t.closest('[data-mega-btn]')) return setMega(!mega.classList.contains('is-open'));
    const op = t.closest('[data-open]');
    if (op) { e.preventDefault(); return openDrawer(op.dataset.open); }
    if (t.closest('[data-close]') || t === overlay) return closeDrawer();
    const add = t.closest('[data-add]');
    if (add) { e.preventDefault(); return addToCart(add, add.hasAttribute('data-buy-now')); }
    const q = t.closest('[data-qty]');
    if (q) {
      if (qtyBusy) return;
      qtyBusy = true;
      /* show the change straight away: dim the row and update the number while the bag is saved */
      const row = q.closest('.co-item,.citem');
      if (row) { row.classList.add('is-busy'); const n = +q.dataset.q > 0 ? $('.qty span', row) : null; if (n) n.textContent = q.dataset.q; }
      return post('cart/change.js', { id: q.dataset.qty, quantity: +q.dataset.q }).then(refreshCart)
        .catch((er) => { toast(er.message); if (row) row.classList.remove('is-busy'); return refreshCart().catch(() => {}); })
        .finally(() => { qtyBusy = false; });
    }
    const gw = t.closest('[data-giftwrap]');
    if (gw) {
      const on = gw.getAttribute('aria-checked') !== 'true';
      gw.setAttribute('aria-checked', on);
      return post('cart/update.js', { attributes: { 'Gift wrap': on ? 'Yes' : '' } }).catch(() => {});
    }
    const w = t.closest('[data-wish]');
    if (w) {
      e.preventDefault();
      const h = w.dataset.wish, a = getW(), k = a.indexOf(h);
      k > -1 ? a.splice(k, 1) : a.push(h);
      setW(a); syncW();
      w.classList.remove('pop'); void w.offsetWidth; w.classList.add('pop');
      if ($('[data-drawer=wish].is-open')) renderWish();
      return;
    }
    if (mega && !t.closest('[data-mega]')) setMega(false);
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeDrawer(); setMega(false); } });

  window.MK = { $, $$, reduce, fine, EASE, io, refreshCart };
  scan(); etas(); syncW(); onScroll();
})();